import type { JobAdsResult } from "@/modules/jobAds/client/api/types"
import type { JobAdDTO, JobAdFromAlgoliaSearchResponse } from "@/modules/jobAds/types/jobAdFromAlgolia"
import type { SearchEngineOptions } from "@/modules/search/searchEngine"
import type { MultipleQueriesQuery, SearchResponse } from "@algolia/client-search"

import { computeJobAdsResultFromAlgolia } from "@/modules/jobAds/client/utils/computeJobAdsResultFromAlgolia"
import { logger } from "@/modules/monitoring/logger"
import { getSearchEngine } from "@/modules/search/searchEngine"

export const getJobAdsFromAlgolia = async (
  searchQueries: MultipleQueriesQuery[],
  searchEngineOptions?: SearchEngineOptions
): Promise<JobAdsResult> => {
  const searchEngine = await getSearchEngine(searchEngineOptions)

  logger.info(`Algolia Search Request: ${JSON.stringify(searchQueries)}`)

  return searchEngine
    .search<JobAdDTO>(searchQueries)
    .then(({ results }) => {
      const mainResults = results[0] as SearchResponse<JobAdDTO>

      logger.info(`Algolia Search Response: ${JSON.stringify({ nbHits: mainResults.nbHits })}`)

      return computeJobAdsResultFromAlgolia({ results } as JobAdFromAlgoliaSearchResponse)
    })
    .catch((error: Error) => {
      const isReverseProxyEnabled =
        process.env.NEXT_PUBLIC_ALGOLIA_USE_REVERSE_PROXY === "true" &&
        !searchEngineOptions?.isDirectAlgoliaConnectionEnabled
      throw new Error(
        `A ${
          error.name
        } occurred when fetching job ads from Algolia (using reverse proxy : ${isReverseProxyEnabled}, appId : ${
          searchEngine.appId
        }, userAgent : ${JSON.stringify(searchEngine.transporter.userAgent)}, hosts : ${JSON.stringify(
          searchEngine.transporter.hosts
        )}, headers : ${JSON.stringify(searchEngine.transporter.headers)}): ${error.message}`
      )
    })
}
